import { render, staticRenderFns } from "./EditPermissionDialog.vue?vue&type=template&id=767d3229&"
import script from "./EditPermissionDialog.vue?vue&type=script&lang=ts&"
export * from "./EditPermissionDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports